module.exports = __webpack_public_path__ + "static/Banner-5-4f8e003c70b0a8602fbe25834dd10eb7.png";